import { cn } from "@tellescope/utils";
import { useUpcomingAndOngoingEvents } from "../../hooks";
import { useTranslation } from "react-i18next";
import { OngoingOrUpcomingEvent } from "./OngoingOrUpcomingEvent";

export interface OngoingAndUpcomingEventsProps {
  timezone?: string;
}

export const OngoingAndUpcomingEvents = ({
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
}: OngoingAndUpcomingEventsProps) => {
  const { t } = useTranslation("calendar");
  const { ongoingEvents, upcomingEvents } = useUpcomingAndOngoingEvents();

  return (
    <>
      <div className="w-full font-light flex flex-col">
        <div
          className={cn(
            "flex flex-col gap-3 border-b p-4",

            !ongoingEvents.length && "text-center italic text-sm text-muted-foreground"
          )}
        >
          <div className="flex gap-2 items-center">
            <span className="relative flex size-2.5">
              <span className="absolute inline-flex size-full animate-ping rounded-full bg-green-400 opacity-75" />
              <span className="relative inline-flex size-2.5 rounded-full bg-green-600" />
            </span>
            <p className="text-sm font-semibold not-italic">{t("Happening Now")}</p>
          </div>
          {ongoingEvents.length
            ? ongoingEvents.map((event) => <OngoingOrUpcomingEvent key={event.id} event={event} timezone={timezone} />)
            : t("No appointments or consultations at the moment")}
        </div>
        <div
          className={cn(
            "flex flex-col gap-3 p-4 opacity-60",
            !upcomingEvents.length && "text-center italic text-sm text-muted-foreground"
          )}
        >
          <div className="flex gap-2 items-center">
            <span className="relative inline-flex size-2.5 rounded-full bg-gray-400" />
            <p className="text-sm font-semibold not-italic">{t("Up next")}</p>
          </div>
          {upcomingEvents.length
            ? upcomingEvents.map((event) => <OngoingOrUpcomingEvent key={event.id} event={event} timezone={timezone} />)
            : t("No upcoming events")}
        </div>
      </div>
    </>
  );
};
